import { Button } from '@festina-life/ui/actions'
import type { ComponentProps } from 'react'

import { useOperationsContext } from '../../workspace/operationsContext'

/**
 * Button wrapper meant to be used for the branch and workspace management panels where
 * multiple buttons are shown together and all depend on the OperationsProvider loading state.
 * While operations are being loaded, buttons that mutate workspace or branch status are shown as
 * disabled rather than with loading spinners in order to avoid too much visual noise in the UI.
 * @param props
 * @returns
 */
export const OperationsLoadedButton = (
  props: ComponentProps<typeof Button>,
) => {
  const { isLoading } = useOperationsContext()
  return <Button {...props} disabled={props.disabled || isLoading} />
}
